import React from 'react';
import Navbar from './global-components/navbar';
import SearchMapSection from './section-components/search-map';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const SearchMap = () => {
    return <div>
        <Navbar />
        <SearchMapSection />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default SearchMap

